<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>设备告警配置</h4>
          <el-button v-allow="'060202'" type="primary" class="adduser" @click="add">添加</el-button>
        </div>
        <el-form :inline="true" :model="dialogformInline" class="demo-form-inline">
          <el-form-item label="传感器名称：" prop="eid">
            <el-select v-model="dialogformInline.eid" @change="valueeid" placeholder="请选择传感器名称">
              <el-option v-for="item in sensorNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="属性名称：" prop="attributeId">
            <el-select v-model="dialogformInline.attributeId" placeholder="请选择属性名称">
              <el-option v-for="item in attributeLiST2" :key="item.id" :label="item.cname" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板名称：" prop="modelAlarmSettingsId">
            <el-select v-model="dialogformInline.modelAlarmSettingsId" placeholder="请选择模板名称">
              <el-option v-for="item in templateNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="onSubmit()">查询</el-button>
            <el-button type="button" ass="button" @click="resetBth()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="deviceName" align="center" label="传感器名称"></el-table-column>
            <el-table-column prop="attributeName" align="center" label="属性名称"></el-table-column>
            <el-table-column prop="modelAlarmSettingsName" align="center" label="告警模板名称"></el-table-column>
            <el-table-column prop="isOpen" align="center" label="状态">
              <template slot-scope="scope">
                <p style="color: red" v-if="scope.row.isOpen == 0">禁用</p>
                <p style="color: #35f10e" v-if="scope.row.isOpen == 1">启用</p>
              </template>
            </el-table-column>

            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.isOpen == 0" @click="handleStatus(scope.row)" type="text" size="small">启用</el-button>
                <el-button v-if="scope.row.isOpen == 1" @click="handleStatus(scope.row)" type="text" size="small">禁用</el-button>
                <el-button @click="handleClick(scope.row.id, 'edit')" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="delObjDeviceAttributeAlarm(scope.row.id)">删除</el-button>
                <el-button @click="handleClick_(scope.row.id,scope.row.isOpen)" type="text" size="small">下发</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
        <!-- 添加-->
        <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="600px" center @closed="resetForm">
          <div class="info-content-container info-content-container-add">
            <el-form :inline="true" :model="dialogformInlineadd" :rules="dialogRules" ref="dialogformInlineadd" class="demo-form-inline" style="padding-left: 60px">
              <el-form-item label="传感器名称：" prop="eid" class="tranf_x">
                <el-select v-model="dialogformInlineadd.eid" @change="cahnge_val" class="input_width tranf_y" placeholder="请选择传感器名称">
                  <el-option v-for="item in sensorNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="属性名称：" prop="attributeId">
                <el-select v-model="dialogformInlineadd.attributeId" @change="attributeIdChange" class="input_width" placeholder="请选择属性名称">
                  <el-option v-for="item in attributeLiST" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="告警模板：" prop="modelAlarmSettingsId">
                <el-select v-model="dialogformInlineadd.modelAlarmSettingsId" class="input_width" placeholder="请选择告警模板">
                  <el-option v-for="item in templateNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm">取消</el-button>
            <el-button type="primary" @click="submitForm('dialogformInlineadd')">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alarmConfiguration',
  data() {
    return {
      centerDialogVisible: false,
      sceneListData: [],
      attributeLiST: [],
      attributeLiST2: [],
      value: '',
      allSysUserList: [], //查询所有用户
      editId: '', //详情id（查询详情时使用））
      id: '',
      list: [], //审批模板详情表(对象)
      remark: '', //备注
      title: '', //标题
      updateId: '', //创建修改人员id
      updateTime: '', //创建修改时间
      dialogTitle: '',
      pagesize: 8,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      genderList: [
        {
          value: '0',
          name: '男'
        },
        {
          value: '1',
          name: '女'
        }
      ],

      dialogformInline: {
        //查询条件（参数）
        sensorName: '',
        attributeId: '',
        modelAlarmSettingsId: ''
      },
      templateNameList: [],
      sensorNameList: [],
      dialogformInlineadd: {
        //添加参数或者编辑参数

        attributeId: '',
        eid: '',
        modelAlarmSettingsId: '',
        id: ''
      },
      dialogRules: {
        // 弹框表单验证
        attributeId: [{ required: true, message: '请选择属性名称', trigger: 'change' }],
        eid: [{ required: true, message: '请选择传感器名称', trigger: 'change' }],
        modelAlarmSettingsId: [{ required: true, message: '请选择告警模板', trigger: 'change' }]
      },
      modelNoListData: [
        {
          label: '全部',
          id: -1
        },
        {
          label: '管理员',
          id: 0
        },
        {
          label: '普通用户',
          id: 1
        }
      ],
      organizationList: [
        {
          label: '全部',
          id: -1
        },
        {
          label: '武汉',
          id: 0
        },
        {
          label: '上海',
          id: 1
        }
      ],

      tableData: [],
      noneList: [],
      editId: '',
      centerDialogVisible: false
    }
  },

  created() {
    this.getNumericals() //查询全部传感器

    this.getModelAlarmSettingss() //查询全部告警模板
    this.getObjDeviceAttributeAlarmList() ///查询告警配置列表
  },
  methods: {
    resetForm() {
      this.centerDialogVisible = false
      this.$refs['dialogformInlineadd'].resetFields()
    },
    // 重置
    resetBth() {
      this.dialogformInline.modelAlarmSettingsId = ''
      this.dialogformInline.eid = ''
      this.dialogformInline.attributeId = ''
      this.onSubmit()
    },
    valueeid() {
      this.getModelRuleAttributes2(this.dialogformInline.eid) //查询全部属性名称
    },
    cahnge_val() {
      this.getModelRuleAttributes(this.dialogformInlineadd.eid) //查询全部属性名称
    },
    attributeIdChange() {
      if (this.dialogformInlineadd.attributeId == '') {
        this.$message.error('请选择传感器名称')
      }
    },
    handleCurrentChange(currentPage) {
      //下一页
      this.currentPage = currentPage
      this.getObjDeviceAttributeAlarmList() //查询列表
    },
    // 查询
    onSubmit() {
      this.getObjDeviceAttributeAlarmList() //查询列表
    },
    //查询告警配置列表
    getObjDeviceAttributeAlarmList() {
      this.loading = true //加载
      this.$api.system
        .getObjDeviceAttributeAlarmList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.dialogformInline.attributeId, //属性id
          this.dialogformInline.eid, //设备id
          this.dialogformInline.modelAlarmSettingsId //设备id
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data
            this.loading = false //关闭加载
            this.total = res.count //
          } else {
            this.loading = false //关闭加载
            this.$message.error(res.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    //删除
    delObjDeviceAttributeAlarm(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.system.delfun(`/pc/objDeviceAttributeAlarm/delObjDeviceAttributeAlarm`, id).then((res) => {
            if (res.code == 200) {
              this.getObjDeviceAttributeAlarmList() //列表刷新
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    add() {
      //添加（新增保存审批模板）
      this.getModelAlarmSettingss()
      this.dialogformInlineadd.id = '' //清空
      this.dialogTitle = '添加设备告警配置'
      this.centerDialogVisible = true
      // this.empty()
    },
    //  查询全部传感器
    getNumericals() {
      this.$api.system.getNumericals().then((res) => {
        if (res.code == 200) {
          this.sensorNameList = res.data //全部传感器
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },

    handleClick(id, type) {
      if (type == 'edit') {
        this.editId = id
        this.dialogTitle = '编辑设备告警配置'
        this.centerDialogVisible = true

        this.getObjDeviceAttributeAlarm(id) //查询告警配置详情
        this.dialogformInlineadd.id = id
      }
    },

    empty() {
      this.dialogformInlineadd.attributeId = ''
      this.dialogformInlineadd.eid = '' //清空
      this.dialogformInlineadd.modelAlarmSettingsId = '' //清空
      this.this.dialogTitle = ''
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '添加告警配置') {
            //新增

            this.saveObjDeviceAttributeAlarm('')
          } else {
            //编辑
            this.saveObjDeviceAttributeAlarm(this.dialogformInlineadd.id)
          }
        } else {
          return false
        }
      })
    },
    cancellation() {
      //弹框取消时
      this.centerDialogVisible = false
    },
    //添加保存审批模板(新增)
    addSaveApproveTemplate(list, id, title) {
      this.loading = true //开启加载
      this.$api.system
        .addSaveApproveTemplate(
          id, //编辑id
          list, //审批模板详情表(对象)
          this.remark, //备注
          title, //标题
          this.updateId, //创建修改人员id
          this.updateTime //创建修改时间
        )
        .then((res) => {
          if (res.code == 200) {
            this.centerDialogVisible = false
            this.loading = false //关闭加载
            this.geTapproveTemplate() //刷新列表
            this.$message({ type: 'success', message: res.msg })
          } else {
            this.centerDialogVisible = false
            this.loading = false //关闭加载
            this.$message.error(res.msg)
          }
        })
    },
    //编辑列表数据接口
    setApproveTemplate() {
      this.loading = true //开启加载
      this.$api.system.setUserMessageList().then((res) => {
        if (res.code == 200) {
          this.loading = false //关闭加载
          this.$meessage({ type: 'success', message: res.msg })
        } else {
          this.loading = false //关闭加载
          this.$meessage.error(res.msg)
        }
      })
    },
    //编辑时获取数据  查询告警配置详情
    getObjDeviceAttributeAlarm(id) {
      this.loading = true //开启加载
      this.$api.system
        .getObjDeviceAttributeAlarm(
          id //详情id（查询详情时使用））
        )
        .then((res) => {
          if (res.code == 200) {
            this.loading = false //关闭加载
            this.dialogformInlineadd.attributeId = res.data.attributeId
            this.dialogformInlineadd.eid = res.data.eid
            this.getNumericals()
            this.getModelRuleAttributes3(res.data.eid) //查询全部属性名称
            this.dialogformInlineadd.modelAlarmSettingsId = res.data.modelAlarmSettingsId
          } else {
            this.loading = false //关闭加载
            this.$meessage.error(res.msg)
          }
        })
    },

    //新增环节
    addNode() {
      this.noneList.push('')
    },
    //查询全部告警模板
    getModelAlarmSettingss() {
      this.$api.system.getModelAlarmSettingss().then((res) => {
        if (res.code == 200) {
          var obj = {}
          obj.name = '全部'
          obj.id = ''
          res.data.unshift(obj)
          this.templateNameList = res.data //全部告警模板
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },
    //查询全部属性名称
    getModelRuleAttributes(id) {
      this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          //  var obj={}
          // obj.cname='全部'
          // obj.id=''
          // res.data.unshift(obj)
          this.attributeLiST = res.data //全部告警模板
          this.dialogformInlineadd.attributeId = res.data[0].id
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },
    getModelRuleAttributes3(id) {
      this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          this.attributeLiST = res.data //全部告警模板
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },
    getModelRuleAttributes2(id) {
      this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          //  var obj={}
          // obj.cname='全部'
          // obj.id=''
          // res.data.unshift(obj)
          this.attributeLiST2 = res.data //全部告警模板
          this.dialogformInline.attributeId = res.data[0].id
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },
    // 保存告警配置
    saveObjDeviceAttributeAlarm(id) {
      this.centerDialogVisible = false
      let data = new FormData()
      data.append('attributeId', this.dialogformInlineadd.attributeId)
      data.append('eid', this.dialogformInlineadd.eid)
      data.append('modelAlarmSettingsId', this.dialogformInlineadd.modelAlarmSettingsId)
      data.append('id', id)
      this.$api.system.saveObjDeviceAttributeAlarm(data).then((res) => {
        if (res.code == 200) {
          this.centerDialogVisible = false
          this.getObjDeviceAttributeAlarmList()
          if (id != '' || id) {
            this.$message({ type: 'success', message: '编辑成功' })
          } else {
            this.$message({ type: 'success', message: res.msg })
          }
        } else {
          this.centerDialogVisible = false
          this.$message.error(res.msg)
        }
      })
    },
    handleClick_(row, status) {
      if (status == 1) {
        this.$api.system.sendAlarmSetToBox(row).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getObjDeviceAttributeAlarmList()
          }
        })
      } else {
        this.$message.warning('当前告警配置状态为禁用，请点击“启用”后再点击下发')
      }
    },
    // 启用、禁用
    handleStatus(row) {
      this.$api.system.openOrCloseDeviceAttributeAlarm({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getObjDeviceAttributeAlarmList()
        }
      })
    }
  }
}
</script>
<style >
@import '../../style/approvalTemplate.scss';

.node_left {
  display: inline-block;
  position: absolute;
  left: 74px;
  top: 150px;
}

.addnode1 {
  margin-left: 113px;
  margin-top: 16px;
}

.dialogformInline {
  width: 320px;
}

.dialogfrom {
  height: 44px;
  width: auto;
  padding-left: 60px;
}

.delbutton {
  margin-left: 10px;
}
</style>